import { Box, FormControlLabel, Radio, RadioGroup, Typography } from "@mui/material";


type MealOptionSharingSettingsProps = {
  shareAllMealOptions: boolean;
  setShareAllMealOptions: (value: boolean) => void;
};

export const MealOptionSharingSettings = ({
  shareAllMealOptions,
  setShareAllMealOptions,
}: MealOptionSharingSettingsProps) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <Box>
        <Typography variant="h4" sx={{ mb: 0.5 }}>
          Meal Option Sharing
        </Typography>
        <Typography variant="body2" sx={({ palette }) => ({ color: palette.text.secondary })}>
          Assigning the meal plan template will auto-scale the meal option amounts to meet individual needs. In the case that meal options are unable to scale for an athlete, please select the preferred option below.
        </Typography>
      </Box>
      <RadioGroup
        value={shareAllMealOptions}
        onChange={e => setShareAllMealOptions(e.target.value === "true")}
        sx={{ display: "flex", gap: 2 }}
      >
        <FormControlLabel
          value={true}
          label={
            <Box>
              <Typography variant="body1">Share all meal options</Typography>
              <Typography variant="body2" sx={({ palette }) => ({ color: palette.text.secondary })}>
                This will include both scaled and unscaled meal options
              </Typography>
            </Box>
          }
          control={<Radio size="medium" />}
        />
        <FormControlLabel
          value={false}
          label={
            <Box>
              <Typography variant="body1">Share scaled meal options</Typography>
              <Typography variant="body2" sx={({ palette }) => ({ color: palette.text.secondary })}>
                This will only include scaled meal options
              </Typography>
            </Box>
          }
          control={<Radio size="medium" />}
        />
      </RadioGroup>
    </Box>
  )};
